export default __webpack_public_path__ + "static/media/Download-cuate.59ff78da.png";